import { fold, fromNullable } from "fp-ts/Option";
import { pipe } from "fp-ts/function";
import every from "lodash/every";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import omit from "lodash/omit";
export const toNonNullableArray = (a) => {
    return pipe(a, fromNullable, fold(() => [], (ids) => ids));
};
export const toNonReadonlyArray = (a) => {
    return pipe(a, fromNullable, fold(() => [], (a) => [...a]));
};
export const isObjectNotEmpty = (value) => !isEmpty(value) && every(value, (v) => !isEmpty(v) || !isNil(v));
export const areValuesEmpty = (value) => every(value, (v) => isEmpty(v) || isNil(v));
export const isAllDefinedExceptOne = (object, property) => isNil(object[property]) &&
    every(omit(object, property), (value) => !isNil(value));
export const isKeyDefined = (object, key) => every(object, (o) => !isNil(o[key]));
//# sourceMappingURL=type-helpers.js.map